export const inspectionTags = [
  'modifyOrAddInspection',
  'master_insp_comp',
  'master_insp_charge',
] as const;
